import React from 'react';
import PropTypes from 'prop-types';

import './loading.scss';

class LoadingComponent extends React.Component {
    render() {
        return <div className={`spinner-wrapper ${this.props.fullScreen ? 'full-screen' : ''}`}>
            <div className="spinner" />
        </div>
    }
}

LoadingComponent.defaultProps = {
    fullScreen: false,
};

LoadingComponent.propTypes = {
    fullScreen: PropTypes.bool,
};

export default LoadingComponent;



// WEBPACK FOOTER //
// ./src/components/core/LoadingComponent/LoadingComponent.js